/*
 *   Copyright (c) 2026, CYBRA Corp. All rights reserved. 
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { UserGroupService } from 'app/services/user-group.service';

declare var $: any;

@Component({
    selector: 'app-user-validation-dialog',
    templateUrl: './user-validation-dialog.component.html'
})
export class UserValidationDialogComponent {

    // Event emitted when the User has completed the validation process
    @Output()
    userValidateEvent = new EventEmitter<Boolean>();

    @Input() 
    overrideRoles : string[] = [];

    // User Name entered by the user
    mUserId : string = "";

    // Password
    mPassword : string = "";

    // Status of the validation
    validationStatus: boolean | null = null;

    // Constructor - Required authentication Service & User Group Service to validate User credentials & User Group
    constructor(
        private mAuthenticationService: AuthenticationService,
        private userGroupService: UserGroupService
    ) { }

    /**
     * Called to show the Dialog
     */
    show(): void {
        this.mUserId = "";
        this.mPassword = "";
        $("#userValidationModal").modal('show');
    }

    /**
     * Called to hide/Cancel the Dialog
     */
    public hideDialog(): void {
        $("#userValidationModal").hide();
        this.userValidateEvent.emit(false);
    }

    /**
     * Called when the User clicks the Override button on UI, check for valid User Credentials
     */
    overrideClicked(): void {
        console.log("Override Clicked! - Email Address: " + this.mUserId + ", Password: " + this.mPassword);
        this.validateUserCredentails().then(async (isValid: boolean) => {
            console.log("User Credentials Validated Successfully!!");
            this.validationStatus = isValid;
            await this.delay(300);
            console.log("Emitting User Validation Event with status: " + isValid);
            this.userValidateEvent.emit(isValid);
        })
    }

    /**
     * Send request to Authentication Service & Group Service to validate the user & role
     * @returns
     */
    async validateUserCredentails(): Promise<boolean> {
        console.log(`Login Attempt... User ID: ${this.mUserId}, Password: ${this.mPassword}`);
        try {
            //Attempt to log in using the current information in the UI
            const loggedIn = await this.mAuthenticationService.login(this.mUserId, this.mPassword);
            if (loggedIn.isSuccess) {
                const overrideUser = await this.mAuthenticationService.getUser();
                const userGroup = await this.userGroupService.getUserGroup(overrideUser.id);
                console.log(`Logged in User's Group: '${userGroup?.name}'`);
                console.log(`Required Override Roles: '${this.overrideRoles}'`);
                if (this.overrideRoles != null &&this.overrideRoles.includes(userGroup.name)) {
                    //User successfully logged into the system, continue with the processing of the Shipment
                    return true;
                }
            } else {
                //Login failed... Show an error
                console.log("Failed to login... Error? " + loggedIn.error);
                return false;
            }
        } catch (error) {
            console.log("Problem logging in... Error: " + error);
        }
        return false;
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


}
